import React from "react";

const InputComponent = React.forwardRef((props, ref) => (
  <div {...props} ref={ref} />
));

export default InputComponent;
